import {
  useLocation,
  useParams,
  Link,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useContext, useEffect, useRef, useState ,useCallback,useMemo} from "react";
import _axios from "../axios";
import buildLink, { path, pixelID } from "../urls";
import SingleProducts from "../components/SingleProduct";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import queryString, { parse } from "query-string";
import ReactPaginate from "react-paginate";
import { LazyLoadImage } from "react-lazy-load-image-component";
import notFound from "../assets/images/page-404.webp";
import CatalogPlaceholder from "./CatalogPlaceholder";
import { useWindowDimensions } from "../components/TopHeader";
import CatalogMobilePlaceholder from "../components/CatalogMobilePlaceholder";
import SeoHandler from "../components/SeoHandler";
import { AccountContext } from "../contexts/AccountContext";
import PointsLoader from "../components/PointsLoader";
import WidgetsLoop from "../components/WidgetsLoop";
import { useFiltersContext } from "../contexts/FiltersContext";
import ReactPixel from "react-facebook-pixel";
import ScrollToTop from "react-scroll-to-top";
import { CurrencyContext } from "../contexts/CurrencyContext";
import DOMPurify from "dompurify";
import { sanitizeHTML } from "../Utils";
import {
  IoIosArrowForward,
  IoIosArrowBack,
  IoIosArrowDown,
} from "react-icons/io";
import { AiOutlineRight, AiOutlineLeft, AiOutlineClose } from "react-icons/ai";
import { LoadingContext } from "react-router-loading";
import Slider from "react-slick";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import RedirectModal from "../components/RedirectModal";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import Cookies from "js-cookie";
import { ExportProductContext } from "../contexts/ExportProductContext";
import JsPDF from "jspdf";
import ReactDOM from "react-dom";
import SingleProductExport from "../components/SingleProductExport";
import { IoMdSearch } from "react-icons/io";
import { FiChevronDown } from "react-icons/fi";
import { CartContext } from "../contexts/CartContext";
import FilterItem from "../components/FilterItem";
import { FaRegTrashAlt } from "react-icons/fa";

function Catalogv2({ type, id, product_id = null }) {
  const [searchParams] = useSearchParams();
  const [accounState] = useContext(AccountContext);
  const [noProductData, setNoProductData] = useState(false);
  const [hasBannerEvent, setHasBannerEvent] = useState();
  const [page, setPage] = useState(1);
  const [start_index, setStartIndex] = useState(0);
  const loadingContext = useContext(LoadingContext);
  const has_filter = searchParams.get("has_filter");
  const [productDisplay, setProductDisplay] = useState("grid");
  const [hasMore, setHasMore] = useState(true);
  const [mobileWidgetsHasMore, setMobileWidgetsHasMore] = useState(true);
  const [widgetsHasMore, setWidgetsHasMore] = useState(true);
  const [Loading, setIsLoading] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [start_index_mobile, setStartIndexMobile] = useState(0);
  const [widgets_limit, setWidgetsLimit] = useState(7);
  const [desktopWidgetsData, setDesktopWidgetsData] = useState([]);
  const [mobileWidgetsData, setMobileWidgetsData] = useState([]);
  const [widgetsData, setWidgetsData] = useState([]);
  const [noDataNoError, setNoDataNoError] = useState(false);
  const { exportProduct, setExportProduct } = useContext(ExportProductContext);
  const { loadingExport, setLoadingExport } = useContext(ExportProductContext);
  const [accountState, accountDispatch] = useContext(AccountContext);
  const [state, dispatch] = useContext(CartContext);
  const [quantity, setQuantity] = useState(1);
  const [addingToCart, setAddingToCart] = useState(false);
  const [viewColor, setViewColor] = useState();
  const [images, setImages] = useState([]);
  const [hasAddToCartError, setHasAddToCartError] = useState(false);
  const [purchased, setPurchased] = useState();
  const [AddToCartError, setAddToCartError] = useState("");
  const selectedIdsRef = useRef([]);
  const catalog_id = id;
  const [hasOption, setHasOption] = useState(false);
  const [newSizeGuide, setShowNewSizeGuide] = useState();
  const [colorSelected, setColorSelected] = useState();
  const [activeOption, setActiveOption] = useState({});
  const [successAdded, setSuccessAdded] = useState(false);
  const [filter_product, setFilterProduct] = useState();
  const [loadingFilters, setLoadingFilters] = useState(true);
  const [showRedirectModal, setShowRedirectModal] = useState(false);
  const [clicked, setClicked] = useState(false);
  const observer = useRef();
  const [resetDone, setResetDone] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isFacebookWebView =
      userAgent.includes("FBAN") || userAgent.includes("FBAV");
    const isInstagramWebView = userAgent.includes("Instagram");

    if (isFacebookWebView || isInstagramWebView) {
      setShowRedirectModal(!clicked);
    }

    if (clicked) {
      setShowRedirectModal(false);
      Cookies.set("clicked", true);
    }
  }, [clicked]);

  useEffect(() => {
    const replacements = {
      category: "category_id",
      manufacturer: "manufacturer_id",
      seller: "seller_id",
      option: "option_id",
    };

    let type = getType();
    type = replacements[type] || type;

    const url = buildLink("filter_product") + type + "=" + catalog_id;
    _axios.get(url).then((response) => {
      setLoadingFilters(true);
      if (response.data.success) {
        setFilterProduct(response.data.filters);
        setLoadingFilters(false);
      }
    });
    
  }, []);



  const lastElementRef = useCallback(
    (node) => {
    
  
      if (observer.current) observer.current.disconnect();
  
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          if (hasMore) {
            setResetDone(true);
            setStartIndex((prev) => prev + widgets_limit);
          }
          if((mobileWidgetsHasMore || widgetsHasMore)){
            setResetDone(true);
            setStartIndexMobile((prev) => prev + widgets_limit);
          }
        }
      });
  
      if (node) observer.current.observe(node);
    },
    [hasMore, Loading, widgets_limit]
  );
  
  const dataRef = useRef([]);
  
  const fetchWidgets = async (catalogType, id, start, web) => {
      if(start == 0 ){
        setLoading(true);
      }
      else{
      setIsLoading(true);
      }
   
    try {
      const endpoint =
        buildLink(`${catalogType}_widgets`, undefined, undefined, window.location.host) +
        id +
        `&source_id=1&start_index=${start}&widgets_limit=${widgets_limit}&web=${web}`;
  
      const response = await _axios.get(endpoint);
      setIsLoading(false);
      setLoading(false);
      const newData = response?.data?.data;
  
      const widgetsArray =
        newData?.desktop_widgets?.widgets ||
        newData?.mobile_widgets?.widgets ||
        newData?.widgets?.widgets ||
        [];
  
      dataRef.current = [...dataRef?.current, ...widgetsArray];

      setDesktopWidgetsData((prev) => {
        const prevWidgets = prev?.desktop_widgets?.widgets || [];
        const newWidgets = newData?.desktop_widgets?.widgets || [];
  
        return {
          ...newData,
          desktop_widgets: {
            ...newData?.desktop_widgets,
            widgets: [...prevWidgets, ...newWidgets],
          },
        };
      });

      const totalPages = newData?.desktop_widgets?.totals?.total_pages;
  

      const currentPage = Math.floor(start / widgets_limit) + 1;
  
  
      setHasMore(currentPage < totalPages);
  
      setMobileWidgetsData((prev) => {
        const prevWidgets = prev?.mobile_widgets?.widgets || [];
        const newWidgets = newData?.mobile_widgets?.widgets || [];
  
        return {
          ...newData,
          mobile_widgets: {
            ...newData?.mobile_widgets,
            widgets: [...prevWidgets, ...newWidgets],
          },
        };
      });

      const mobileWidgetstotalPages = newData?.mobile_widgets?.totals?.total_pages;

  

      const mobileWidgetsCurrentPage = Math.floor(start / widgets_limit) + 1;
  
  
      setMobileWidgetsHasMore(mobileWidgetsCurrentPage < mobileWidgetstotalPages);
  
  
      setWidgetsData((prev) => {
        const prevWidgets = prev?.widgets?.widgets || [];
        const newWidgets = newData?.widgets?.widgets || [];
  
        return {
          ...newData,
          widgets: {
            ...newData?.widgets,
            widgets: [...prevWidgets, ...newWidgets],
          },
        };
      });

      const widgetstotalPages = newData?.widgets?.totals?.total_pages;

  

      const widgetsCurrentPage = Math.floor(start / widgets_limit) + 1;
  
  
      setWidgetsHasMore(widgetsCurrentPage < widgetstotalPages);


      setResetDone(false);
    } catch (error) {
      console.error("Widget fetch failed:", error);
    } finally {
      setLoading(false);
    }
  };




  useEffect(() => {
    setResetDone(false); 
  
    setData([]);
    setStartIndex(0);
    setStartIndexMobile(0);
  
    setDesktopWidgetsData([]);
    setMobileWidgetsData([]);
    setWidgetsData([]);
  

    const timeout = setTimeout(() => {
      setResetDone(true);
    }, 0); 
  
    return () => clearTimeout(timeout);
  }, [type,catalog_id]);
  

  const prevFetchParams = useRef(null);

  useEffect(() => {
    if (!resetDone || has_filter || state.noWidgets) return;
  
    const web = window.innerWidth > 650 ? "desktop" : "mobile";
    const start = web === "desktop" ? start_index : start_index_mobile;
    const id = catalog_id;
  
    const currentParams = { type, id, start, web };

    if (
      prevFetchParams.current &&
      JSON.stringify(prevFetchParams.current) === JSON.stringify(currentParams)
    ) {
      return;
    }
  
    prevFetchParams.current = currentParams;
  
    const fetchData = async () => {
      if (type === "category") {
        await fetchWidgets("category", id, start, web);
      } else if (type === "manufacturer") {
        await fetchWidgets("manufacturer", id, start, web);
      } else if (type === "seller") {
        await fetchWidgets("seller", id, start, web);
      }
    };
  
    fetchData();
  }, [resetDone, start_index, start_index_mobile, has_filter, type, catalog_id, state.noWidgets]);
  
  
  
  

  const DesktopWidgetsList = useMemo(() => {
    if (
      (page === undefined || page < 2) &&
      desktopWidgetsData?.desktop_widgets?.widgets?.length > 0 &&
      desktopWidgetsData?.desktop_widgets_status === "1" &&
      !has_filter
    ) {
      return desktopWidgetsData?.desktop_widgets?.widgets.map((widget, index) => {
        const isLast = index === desktopWidgetsData?.desktop_widgets?.widgets?.length - 1;
        return (
          <div
            className="px-3"
            key={widget.mobile_widget_id || widget.id || index}
            ref={isLast ? lastElementRef : null}
          >
            <WidgetsLoop widget={widget}  category="category"/>
          </div>
        );
      });
    }
    return null;
  }, [
    desktopWidgetsData?.desktop_widgets?.widgets,
    desktopWidgetsData?.desktop_widgets_status,
    page,
    has_filter,
    lastElementRef,
  ]);

  const MobileWidgetsList = useMemo(() => {
    if (
      (page === undefined || page < 2) &&
      mobileWidgetsData?.mobile_widgets?.widgets?.length > 0 &&
      mobileWidgetsData?.mobile_widgets_status === "1" &&
      !has_filter
    ) {
      return mobileWidgetsData.mobile_widgets?.widgets.map((widget, index) => {
        const isLast = index === mobileWidgetsData?.mobile_widgets?.widgets?.length - 1;
        return (
          <div
            className="px-3"
            key={widget.mobile_widget_id || widget.id || index}
            ref={isLast ? lastElementRef : null}
          >
            <WidgetsLoop widget={widget}  />
          </div>
        );
      });
    }
    return null;
  }, [
    mobileWidgetsData?.mobile_widgets?.widgets,
    mobileWidgetsData?.mobile_widgets_status,
    page,
    has_filter,
    lastElementRef,
  ]);


  const WidgetsList = useMemo(() => {
    if (
      (page === undefined || page < 2) &&
      widgetsData?.widgets?.widgets?.length > 0 &&
      widgetsData?.widgets_status === "1" &&
      !has_filter
    ) {
      return widgetsData.widgets.widgets.map((widget, index) => {
        const isLast = index === widgetsData.widgets.widgets.length - 1;
        return (
          <div
            className="px-3"
            key={widget.widget_id || widget.id || index}
            ref={isLast ? lastElementRef : null}
          >
            <WidgetsLoop widget={widget}  />
          </div>
        );
      });
    }
    return null;
  }, [
    widgetsData?.widgets?.widgets,
    widgetsData?.widgets_status,
    page,
    has_filter,
    lastElementRef,
  ]);

  // const [isError, setIsError] = useState(false);
  // const [uiFilters, setUiFilters] = useState([])
  const history = useNavigate();
  const location = useLocation();
  const banner_image_id = location.state?.banner_image_id
    ? location.state?.banner_image_id
    : "";
  const source_type = location.state?.source_type
    ? location.state?.source_type
    : "";
  const source_type_id = location.state?.source_type_id
    ? location.state?.source_type_id
    : "";

  const [display, setDisplay] = useState("grid");
  const [productData, setProductData] = useState([]);
  const [empty, setEmpty] = useState(true);
  const [countDownPointer, setCountDownPointer] = useState();
  const curr = useContext(CurrencyContext);
  const [sort, setSort] = useState({
    value: "p2co.sort_order-ASC",
    text: "Default",
  });
  const [limit, setLimit] = useState({
    value: "50",
    text: "50",
  });
  const path1 = location.pathname;
  const lastLocation = useRef({
    path: "",
  });
  // Add this at the top of your component, before the return statement
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [currentFilter, setCurrentFilter] = useState(null);
  const filter_categories = searchParams.get("filter_categories");
  const [optionParent, setOptionParent] = useState("");
  const filter_manufacturers = searchParams.get("filter_manufacturers");
  const filter_sellers = searchParams.get("filter_sellers");
  const dataInformation = useContext(CurrencyContext);
  const filter_options = searchParams.get("filter_options");
  const filter = searchParams.get("filter");
  const adv_filters = searchParams.get("adv_filters");
  const last = searchParams.get("last");

  // const page = searchParams.get('page');
  // const sort = searchParams.get('sort');
  const order = searchParams.get("order");
  // const limit = searchParams.get('limit');
  const openOverlay = (key) => {
    console.log(key);
    setCurrentFilter(key);
    setIsOverlayOpen(true);
    checkFilters(filter_product[key].id);
  };

  const closeOverlay = () => {
    setIsOverlayOpen(false);
    setCurrentFilter(null);
  };

  useEffect(() => {
    if (product_id) {
      getProduct();
    }
  }, [product_id]);

  function downloadDatasheet() {
    const link = document.createElement("a");
    link.href = productData?.datasheet;
    link.setAttribute("download", productData?.sku + ".pdf");
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
  }

  async function initializeReactPixel() {
    const module = await import("react-facebook-pixel");
    return module.default;
  }

  function getProduct() {
    const q_s = queryString.parse(location.search);
    var page = q_s.page ? q_s.page : 1;
    var link =
      buildLink("product", undefined, window.innerWidth) +
      `${
        product_id +
        `${
          window.config["site-url"].indexOf("ishtari") > -1 ? "&clear=true" : ""
        }`
      }${
        location?.state?.fromSearch ? "&from_search=1" : ""
      }&source_id=1&part_one=true`;

    _axios.get(link).then((response) => {
      const data = response.data;
      if (!data?.success) {
        setNoProductData(true);

        loadingContext.done();
      } else {
        setProductData(data.data);
        console.log(JSON.stringify(data.data));

        var dataSocial = data.data.social_data;
        dataSocial["fbp"] = Cookies.get("_fbp");
        dataSocial["fbc"] = Cookies.get("_fbc");
        dataSocial["ttp"] = Cookies.get("_ttp");
        dataSocial["link"] = window.location.href;
        dataSocial["view_type"] = "product";
        dataSocial["view_type_id"] = product_id;

        data.data.options.length > 0 &&
          setOptionParent(data.data.options[0]["product_option_id"]);
        setImages(data.data.images);
        setHasOption(data?.data.options?.length > 0);
        if (
          source_type === "" ||
          source_type === null ||
          typeof source_type === "undefined"
        ) {
          dataSocial["ignore"] = false;
        } else {
          dataSocial["source_type"] = source_type;
          dataSocial["source_type_id"] = source_type_id;
          dataSocial["banner_image_id"] = banner_image_id
            ? banner_image_id
            : "";
        }
      }
    });
  }

  function addToCart(bundle) {
    setHasAddToCartError(false);
    setAddingToCart(true);
    let obj = {
      product_id,
      quantity,
    };
    if (hasOption) {
      let o = {};
      const op = optionParent.toString();
      o[op] = activeOption["product_option_value_id"];
      obj["option"] = o;
      console.log(op);
    }
    console.log("hasOption: " + hasOption);
    let error = "";
    console.log("obj1: " + JSON.stringify(obj));
    _axios
      .post(
        buildLink("cart", undefined, window.innerWidth) + "&source_id=1",
        bundle === undefined ? obj : bundle
      )
      .then((response) => {
        const data = response.data;
        if (data.success !== true) {
          // There is an error
          setHasAddToCartError(true);
          if (!hasOption) {
            error = data?.errors[0]?.errorMsg;
          } else {
            error = data?.errors[0]?.errorMsg;
          }
          // alert(error)
          setAddToCartError(error);
          setAddingToCart(false);
        } else {
          dispatch({
            type: "loading",
            payload: true,
          });
          _axios
            .get(buildLink("cart", undefined, window.innerWidth))
            .then((response_data) => {
              dispatch({
                type: "setProducts",
                payload: response_data.data?.data?.products,
              });

              dispatch({
                type: "setProductsCount",
                payload: response_data?.data?.data?.total_product_count,
              });
              dispatch({
                type: "setTotals",
                payload: response_data.data?.data?.totals,
              });
              dispatch({
                type: "loading",
                payload: false,
              });
            });
          // if (!accountstate.admin) {
          // ---> Facebook PIXEL <---

          // const advancedMatching = {
          //   em: productData?.social_data?.email,
          //   fn: productData?.social_data?.firstname,
          //   ln: productData?.social_data?.lastname,
          //   external_id: productData?.social_data?.external_id,
          //   country: productData?.social_data?.country_code,
          //   fbp: Cookies.get("_fbp")

          // };
          // ReactPixel.init(pixelID, advancedMatching, {
          //   debug: true,
          //   autoConfig: false
          // });
          // ReactPixel.pageView();
          //   ReactPixel.fbq("track", "PageView");
          if (data) {
            const data = response?.data?.data?.social_data;

            ReactPixel.fbq(
              "track",
              "AddToCart",
              {
                content_type: "product",
                content_ids: data?.content_ids,
                content_name: data?.name,
                value: data?.value,
                content_category: productData?.breadcrumbs?.category[0]?.name,
                currency: data?.currency,
                fbp: Cookies.get("_fbp"),
              },
              { eventID: data?.event_id }
            );
          }
          // }

          var dataSocial = response?.data?.data?.social_data;
          dataSocial["link"] = window.location.href;
          dataSocial["fbp"] = Cookies.get("_fbp");
          dataSocial["fbc"] = Cookies.get("_fbc");
          dataSocial["ttp"] = Cookies.get("_ttp");
          // dataSocial["view_type"] = "product";
          // dataSocial["view_type_id"] = product_id;
          // dataSocial["source_type"] = source_type;
          // dataSocial["source_type_id"] = source_type_id;
          // dataSocial["banner_image_id"] = banner_image_id
          //   ? banner_image_id
          //   : "";
          _axios
            .post(dataInformation?.data?.analytics_url, dataSocial)
            .then((response) => {
              const data = response.data;
              if (data.success === true) {
              }
            });
          setSuccessAdded(true);

          setTimeout(() => {
            // setCountDown(false)
            setAddingToCart(false);
          }, 3000);
        }
      });
  }

  function gtag_report_conversion(obj) {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    if (!accountState.admin) {
      var price = 10;
      if (data.special_net_value) {
        price = data.special_net_value;
      } else {
        price = data.price_net_value;
      }
      if (
        window.location.host === "www.ishtari.com" ||
        window.location.host === "next.ishtari.com" ||
        window.location.host === "ishtari-mobile.com"
      ) {
        var callback = addToCart(obj);
        gtag("event", "conversion", {
          send_to: "AW-991347483/FGk5CJ3V3owYEJuG29gD",
          value: price,
          currency: "USD",
          event_callback: callback,
        });
        return false;
      } else if (
        window.location.host === "next.ishtari.com.gh" ||
        window.location.host === "www.ishtari.com.gh"
      ) {
        const callback = addToCart(obj);
        gtag("event", "conversion", {
          send_to: "AW-10993907106/6Y9jCLfUipEYEKLrpvoo",
          value: price,
          currency: "USD",
          event_callback: callback,
        });
        return false;
      } else {
        addToCart(obj);
      }
    } else {
      addToCart(obj);
    }
  }

  function checkFilter(type, name, filter) {
    const toArray = (data) => {
      return data ? data.split(",").map((item) => item.trim()) : [];
    };

    const filterCategories = toArray(filter_categories || "");
    const filterManufacturers = toArray(filter_manufacturers || "");
    const filterSellers = toArray(filter_sellers || "");
    const advFilters = toArray(adv_filters || "");

    const filterId = filter["id"] ? filter["id"].toString().trim() : "";

    if (filter_options && (name === "Color" || name === "Light color")) {
      return filter_options.includes(filterId)
        ? "rounded-full border border-dblue"
        : "rounded-full border relative border-dgreyRate cursor-pointer hover:shadow";
    } else if (
      filter_options &&
      (name === "Shoes Size" ||
        name === "Size by Age" ||
        name === "jeans Size" ||
        name === "Socks")
    ) {
      return filter_options.includes(filterId)
        ? "border rounded text-dblue border-dblue p-2"
        : "border rounded relative border-dgreyRate cursor-pointer hover:shadow p-2";
    } else if (
      type === "filter_categories" ||
      type === "filter_manufacturers" ||
      type === "filter_sellers" ||
      type === "adv_filters"
    ) {
      if (type === "filter_categories" && filterCategories.includes(filterId)) {
        return <input type="checkbox" className="" defaultChecked={true} />;
      }

      if (
        type === "filter_manufacturers" &&
        filterManufacturers.includes(filterId)
      ) {
        return <input type="checkbox" className="" defaultChecked={true} />;
      }

      if (type === "filter_sellers" && filterSellers.includes(filterId)) {
        return <input type="checkbox" className="" defaultChecked={true} />;
      }

      if (type === "adv_filters" && advFilters.includes(filterId)) {
        return <input type="checkbox" className="" defaultChecked={true} />;
      }

      return <input type="checkbox" className="" />;
    } else {
      if (filter_options && type === "filter_options") {
        return filter_options.includes(filterId) ? (
          <input type="checkbox" className="" defaultChecked={true} />
        ) : (
          <input type="checkbox" className="" />
        );
      }
      return <input type="checkbox" className="" />;
    }
  }

  const [borderColors, setBorderColors] = useState({});
  const [selectedItemIds, setSelectedItemIds] = useState([]);

  const checkFilters = (filterType) => {
    // console.log("111111", borderColors);
    // console.log("222222", selectedItemIds);

    const urlParams = new URLSearchParams(location.search);

    if (!filterType) {
      // console.error("filterType is undefined!");
      return;
    }

    let selectedIds = [];

    if (!urlParams.has(filterType)) {
      // console.log("Filter does not exist in the URL params:", filterType);

      setBorderColors({});
      setSelectedItemIds([]);
      selectedIdsRef.current = [];
      return;
    }

    // console.log("Filter exists:", filterType);

    const filterValues = urlParams.get(filterType);
    if (filterValues) {
      selectedIds = filterValues.split(",").map((id) => parseInt(id, 10));

      setSelectedItemIds((prevIds) => {
        const newIds = [...new Set([...prevIds, ...selectedIds])];
        return newIds;
      });
      selectedIdsRef.current = selectedIds;

      const colorBorders = {};
      selectedIds.forEach((id) => {
        colorBorders[id] = "border-dblue";
      });
      setBorderColors(colorBorders);
      // console.log("colorBorders:", colorBorders);
    } else {
      console.error("No values found for filterType:", filterType);
    }

    // console.log("selectedIds:", selectedIds);
  };

  const handleCheckboxClick = (itemId) => {
    const idNumber = Number(itemId);

    const isSelected = selectedIdsRef.current.includes(idNumber);

    if (isSelected) {
      selectedIdsRef.current = selectedIdsRef.current.filter(
        (id) => id !== idNumber
      );
    } else {
      selectedIdsRef.current.push(idNumber);
    }

    setSelectedItemIds([...selectedIdsRef.current]);

    const colorBorders = {};
    selectedIdsRef.current.forEach((id) => {
      colorBorders[id] = "border-dblue";
    });

    setBorderColors(colorBorders);
  };

  <button
    className="px-8 py-2 bg-dblue1 text-white rounded-md mr-4 mb-6 font-semibold"
    onClick={() =>
      parseFilter1(filter_product[currentFilter].id, selectedIdsRef.current)
    }
  >
    Apply
  </button>;

  function parseFilter1(filter_type, newIds) {
    let url = location.pathname.split("?")[0];
    let queryParams = new URLSearchParams(location.search);

    const existingIds = queryParams.get(filter_type)
      ? queryParams.get(filter_type).split(",").map(Number)
      : [];

    const combinedIds = new Set([...existingIds]);

    newIds.forEach((id) => {
      combinedIds.add(id);
    });

    existingIds.forEach((id) => {
      if (!newIds.includes(id)) {
        combinedIds.delete(id);
      }
    });

    if (combinedIds.size > 0) {
      queryParams.set(filter_type, Array.from(combinedIds).join(","));
    } else {
      queryParams.delete(filter_type);
    }

    const filtersExist = [
      "filter_manufacturers",
      "filter_sellers",
      "filter_categories",
      "filter_options",
      "adv_filters",
    ].some((filter) => queryParams.has(filter));

    if (filtersExist) {
      if (filter_type !== "page") {
        const lastSegment =
          filter_type !== "adv_filters" ? filter_type.slice(7, 8) : "f";
        queryParams.set("last", lastSegment);
      }
      queryParams.delete("has_filter");
      queryParams.set("has_filter", "true");
    } else {
      queryParams.delete("has_filter");
      queryParams.delete("last");
    }

    const paramsArray = Array.from(queryParams.entries());
    const hasFilterParam = paramsArray.find(([key]) => key === "has_filter");
    const otherParamsArray = paramsArray.filter(
      ([key]) => key !== "has_filter"
    );

    let newQueryString = hasFilterParam
      ? `${hasFilterParam[0]}=${hasFilterParam[1]}&`
      : "";
    newQueryString += otherParamsArray
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    let newUrl = newQueryString ? `${url}?${newQueryString}` : url;
    newUrl = newUrl.replace(/%2C/g, ",");

    selectedIdsRef.current = Array.from(combinedIds);
    setIsOverlayOpen(false);
    history(newUrl);
  }

  const handleSearch = () => {
    const tempName = inputRef.current.value;
    setItemName(tempName);
  };

  const inputRef = useRef(null);
  const [itemName, setItemName] = useState("");

  const [searchQuery, setSearchQuery] = useState("");

  const { userFilters, setUserFilters } = useFiltersContext();
  const { width } = useWindowDimensions();
  const oldFilters = location.state?.oldFilters;
  const [showSort, setShowSort] = useState(false);
  const [showLimit, setShowLimit] = useState(false);
  const [data, setData] = useState();
  const [loading,setLoading]=useState(true);
  const [filters, setFilters] = useState();
  const [likedData, setLikedData] = useState([]);
  const catalog_name = useParams().name;
  const url = location.pathname;
  const parsedQueryString = queryString.parse(location.search);
  // Get current route type (category,seller,manufacturer)
  const [mobileSort, showMobileSort] = useState(false);
  const [mobileFilter, showMobileFilter] = useState(false);
  const urlRef = useRef(location?.pathname);
  const { errPermission, setErrPermission } = useContext(ExportProductContext);
  const [topFilter, setTopFilter] = useState({
    show: false,
    name: "",
    offset: 0,
  });

  const priceFrom = useRef("");
  const priceTo = useRef("");
  const [filterValue, setFilterValue] = useState({
    start_price: priceFrom?.current?.value,
    end_price: priceTo?.current?.value,
  });
  // const [firstAttemp, setFirstAttemp] = useState(true);

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  function statesSetter(data) {
    const parsedQueryString = queryString.parse(location.search);
    if (parsedQueryString.sort) {
      data?.sorts?.map((s) => {
        if (s.value === parsedQueryString.sort) {
          setSort(s);
        }
        return s;
      });
    }
    if (parsedQueryString.limit) {
      data?.limits?.map((l) => {
        if (l.value === parsedQueryString.limit) {
          setLimit(l);
        }
        return l;
      });
    }
    if (parsedQueryString.page) {
      setPage(parsedQueryString.page);
    }
  }

  const checkErrorFilters = () => {
    let params = new URLSearchParams(location.search);
    /// GET THE LAST CLICKED ELEMENT
    const last = params && params.get("last");

    /// CHECK WHICH TYPE IT IS THEN DELETING IT FROM THE URL
    if (last === "s") {
      params && params.delete("filter_sellers");
    } else if (last === "m") {
      params && params.delete("filter_manufacturers");
    } else if (last === "o") {
      params && params.delete("filter_options");
    } else if (last === "c") {
      params && params.delete("filter_categories");
    } else if (last === "f") {
      params && params.delete("adv_filters");
    }
    //// PUSH WITH THE SAME PATHNAME AND NEW SEARCH VALUE TO SOLVE THE PROBLEM
    history(location.pathname + "?" + params.toString());
  };

  const checkMainFilter = (filter) => {
    let temp = "catalog-top-filter-not-selected";
    filter.items.map((item) => {
      if (userFilters[filter.id].includes(item.id)) {
        return (temp = "catalog-top-filter-selected");
      }
    });
    return temp;
  };

  const clearFilter = (filter) => {
    setTopFilter({
      show: false,
      name: "",
      offset: 0,
    });

    let params = new URLSearchParams(location.search);
    if (filter.id === "filter_sellers") {
      params && params.delete("filter_sellers");
    } else if (filter.id === "filter_manufacturers") {
      params && params.delete("filter_manufacturers");
    } else if (filter.id === "filter_options") {
      params && params.delete("filter_options");
    } else if (filter.id === "filter_categories") {
      params && params.delete("filter_categories");
    } else if (filter.id === "adv_filters") {
      params && params.delete("adv_filters");
    }

    let temp = "";

    if (
      params.get("filter_sellers") ||
      params.get("filter_manufacturers") ||
      params.get("filter_options") ||
      params.get("filter_categories") ||
      params.get("adv_filters")
    ) {
      temp = "?" + params.toString();
    }

    //// PUSH WITH THE SAME PATHNAME AND NEW SEARCH VALUE TO SOLVE THE PROBLEM
    history(location.pathname + temp);
  };

  const handleTopFilter = (name) => {
    const off = document.getElementById(`${name}`).offsetLeft;

    if (width > 650) {
      if (topFilter.name === name && topFilter.show === true) {
        setTopFilter({
          show: false,
          name: name,
          offset: topFilter.offset,
        });
      } else if (topFilter.name !== name && topFilter.show === true) {
        setTopFilter({
          show: true,
          name: name,
          offset: off > 531 ? 531 : off,
        });
      } else {
        setTopFilter({
          show: true,
          name: name,
          offset: off > 531 ? 531 : off,
        });
      }
    } else {
      setTopFilter({
        show: true,
        name: name,
        offset: off > 531 ? 531 : off,
      });
    }
  };

  //page view conversion for google ads
  useEffect(() => {
    if (!accounState.admin) {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      if (window.location.host === "www.ishtari.com") {
        gtag("event", "conversion", {
          send_to: "AW-991347483/pc3dCIaww44YEJuG29gD",
          ids: data?.social_data?.content_ids,
        });
      } else if (window.location.host === "www.ishtari.com.gh") {
        gtag("event", "conversion", {
          send_to: "AW-10993907106/31DICLmKppEYEKLrpvoo",
          ids: data?.social_data?.content_ids,
        });
      }
    }
  }, [data, accounState.admin]);

  useEffect(() => {
    // console.log(showLimit, showSort);
    document.removeEventListener("mousedown", handleClick);
  });
  function handleClick() {
    if (showLimit === true) setShowLimit(!showLimit);
    if (showSort === true) setShowSort(!showSort);
  }
  const limitRef = useRef(null);
  useOutsideLimit(limitRef);

  function useOutsideLimit(limitRef) {
    useEffect(() => {
      const checkIfClickedOutside = (e) => {
        // If the menu is open and the clicked target is not within the menu,
        if (
          showLimit &&
          limitRef.current &&
          !limitRef.current.contains(e.target)
        ) {
          if (showLimit) setShowLimit(false);
        }
      };

      document.addEventListener("mousedown", checkIfClickedOutside);

      return () => {
        // Cleanup the event listener

        document.removeEventListener("mousedown", checkIfClickedOutside);
      };
    }, [showLimit]);
  }

  const sortRef = useRef(null);
  useOutsideSort(sortRef);

  function useOutsideSort(sortRef) {
    useEffect(() => {
      const checkIfClickedOutside = (e) => {
        // If the menu is open and the clicked target is not within the menu,
        if (
          showSort &&
          sortRef.current &&
          !sortRef.current.contains(e.target)
        ) {
          if (showSort) setShowSort(false);
        }
      };

      document.addEventListener("mousedown", checkIfClickedOutside);

      return () => {
        // Cleanup the event listener

        document.removeEventListener("mousedown", checkIfClickedOutside);
      };
    }, [showSort]);
  }
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */

      if (topFilter.show) {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setTopFilter({
              show: false,
              name: topFilter.name,
              offset: topFilter.offset,
            });
          }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          // Unbind the event listener on clean up
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }
    }, [ref, topFilter]);
  }

  function getData() {
    setLoadingProducts(true);
    _axios.get(parseUrl()).then((response) => {
      if (response.data.error || response.data.breadcrumbs?.length === 0) {
        setEmpty(true);
        setData(response?.data?.data);
        setLoadingProducts(false);
        setNoDataNoError(true);
        loadingContext.done();
        return;
      }
    
      const is_filter = window.location.href.indexOf("has_filter") > 0;
      let data;
      if (is_filter) {
        data = response?.data?.data;
      } else {
        data = response?.data?.data;
      }
      if (data?.error) {
        // console.log("found error in useEffect");
        checkErrorFilters();
      }
      //console.log(data);
      statesSetter(data);
      setData(data);
      setLoadingProducts(false);
      setLoading(false);
      loadingContext.done();
      location.state = {
        oldFilters: data?.filters,
      };

      setFilters(!is_filter ? data?.filters : data?.filters); //replace filters with test_fillter

      // if (!state.admin) {
       

      var dataSocial = data?.social_data;

      if (
        typeof dataSocial !== "undefined" &&
        dataSocial?.content_ids.length !== 0
      ) {
        dataSocial["fbp"] = Cookies.get("_fbp");
        dataSocial["fbc"] = Cookies.get("_fbc");
        dataSocial["ttp"] = Cookies.get("_ttp");
        dataSocial["link"] = window.location.href;
        dataSocial["view_type"] = getType();
        dataSocial["view_type_id"] = catalog_id;
        if (
          source_type === "" ||
          source_type === null ||
          typeof source_type === "undefined"
        ) {
          dataSocial["ignore"] = false;
        } else {
          dataSocial["source_type"] = source_type;
          dataSocial["source_type_id"] = source_type_id;
          dataSocial["banner_image_id"] = banner_image_id
            ? banner_image_id
            : "";
        }

        _axios
          .post(dataInformation?.data?.analytics_url, dataSocial)
          .then((response) => {
            const data = response.data;
            if (data.success === true) {
            }
          });
      }
    });
  }

  const firstPath = window.location.href.split("/")[3];

  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  useEffect(() => {
    if (
      (window.config["site-url"] === "https://flo.sari3.com" ||
        localStorage.getItem("site-local-name") === "flo" ||
        firstPath === "bey") &&
      !accounState.admin
    ) {
      window.location.href = "/";
    }
  }, [accounState.admin]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
    var url1 = new URL(window.location);
    var filter_price = url1.searchParams.get("filter_price");
    setFilterValue({
      start_price: filter_price?.split("-")[0],
      end_price: filter_price?.split("-")[1],
    });

    getData();
    if (location.pathname !== urlRef.current) {
      setUserFilters({
        filter_sellers: [],
        filter_categorie: [],
        filter_manufacturers: [],
        adv_filters: [],
        filter_options: [],
      });
      urlRef.current = location.pathname;
    }
    if (history.action === "POP") {
      let sellerIndex;
      let brandIndex;
      let optionsIndex;
      let advfiltersIndex;
      let categoryIndex;
      sellerIndex = window.location.href.indexOf("filter_sellers");
      brandIndex = window.location.href.indexOf("filter_manufacturers");
      categoryIndex = window.location.href.indexOf("filter_categories");
      advfiltersIndex = window.location.href.indexOf("adv_filters");

      optionsIndex = window.location.href.indexOf("filter_options");

      const value = Math.max(
        sellerIndex,
        brandIndex,
        optionsIndex,
        advfiltersIndex,
        categoryIndex
      );
      if (value === sellerIndex) {
        setUserFilters({
          ...userFilters,
          filter_options: [],
          filter_categories: [],
          filter_manufacturers: [],
          adv_filters: [],
        });
      }
      if (value === categoryIndex) {
        setUserFilters({
          ...userFilters,
          filter_options: [],
          filter_manufacturers: [],
          filter_sellers: [],
          adv_filters: [],
        });
      }
      if (value === brandIndex) {
        setUserFilters({
          ...userFilters,
          filter_sellers: [],
          filter_categories: [],
          filter_options: [],
          adv_filters: [],
        });
      }
      if (value === advfiltersIndex) {
        setUserFilters({
          ...userFilters,
          filter_sellers: [],
          filter_categories: [],
          filter_manufacturers: [],
          filter_options: [],
        });
      }
     
    }
  
    if (id !== lastLocation.current.path) {
      lastLocation.current.path = id;
      setSort({
        value: "p2co.sort_order-ASC",
        text: "Default",
      });
      setDisplay({
        value: "50",
        text: "50",
      });
    }
    return () => {
      setEmpty(false);
      //setIsError(false);

      // setUserFilters({
      //   filter_seller_id: [],
      //   filter_category_id: [],
      //   filter_manufacturer_id: [],
      //   filter_options: [],
      // })
    };
  }, [location, accounState.admin]);

  let productArray = [];
  useEffect(() => {
    // Ensure `data` and its required properties are defined before running the effect
    if (data && data.products?.length > 0 && !accounState.admin) {
      const productDetails = [];

      data.products.forEach((p) => {
        productArray.push(p.product_id);
        productDetails.push({ id: p.product_id, quantity: p.quantity });
      });

      // ---> Facebook PIXEL <---
      const advancedMatching = {
        em: data.social_data?.email,
        fn: data.social_data?.firstname,
        ln: data.social_data?.lastname,
        external_id: data.social_data?.external_id,
        country: data.social_data?.country_code,
        fbp: Cookies.get("_fbp"),
        client_ip_address: data.social_data?.ip,
        client_user_agent: data.social_data?.user_agent,
      };

      // console.log("Initializing ReactPixel with:", { pixelID, advancedMatching });
      ReactPixel.init(pixelID, advancedMatching, {
        debug: true,
        autoConfig: false,
      });

      // console.log("ReactPixel initialized. Triggering page view...");
      ReactPixel.pageView();

      // console.log("Tracking 'PageView' with ReactPixel...");
      ReactPixel.fbq("track", "PageView");

      // console.log("Tracking 'ViewContent' with ReactPixel...", {
      //   content_type: "product",
      //   content_ids: productArray,
      //   contents: productDetails,
      //   content_name: data.social_data?.name,
      //   eventID: data.social_data?.event_id,
      // });

      window.fbq(
        "track",
        "ViewContent",
        {
          content_type: "product",
          content_ids: productArray,
          contents: productDetails,
          content_name: data.social_data?.name,
        },
        { eventID: data.social_data?.event_id }
      );

      return () => {
        setEmpty(false);
        productArray = [];
      };
    }
  }, [data, filters, accounState.admin]);

  // function checkCookies() {
  //   const adminToken = Cookies.get("AGlNferqw");
  //   console.log(adminToken);
  //   if (typeof adminToken != "undefined") {
  //     return true;
  //   } else{
  //     return false;
  //   }
  // }

  // useEffect(()=>{
  //   checkCookies();
  // },[state.admin])

  // Prepare the url
  function parseUrl(queries = false, exportProducts = false) {
    let url_type =
      window.location.href.indexOf("has_filter") < 0 ? "default" : "filter";
    if (!exportProducts) {
      setData({});
    }

    if (url_type === "default") {
      const q_s = queryString.parse(location.search);

      q_s.page = q_s.page ? q_s.page : page;
      q_s.limit = q_s.limit ? q_s.limit : limit.value;
      q_s.sort = q_s.sort ? q_s.sort : "p2co.sort_order";
      q_s.order = q_s.order ? q_s.order : "ASC";

      q_s.source_id = 1;
  
      let final_queries = "&" + queryString.stringify(q_s);
      return !queries
        ? buildLink(getType(), undefined, window.innerWidth) +
            catalog_id +
            final_queries +
            "&without_widget=true"+
            `${accounState.admin ? "&adm_quantity=true&clear" : ""}`
        : final_queries + `${accounState.admin ? "&adm_quantity=true" : ""}`;
    } else {
      //heree

      const q_s = queryString.parse(location.search);

      let type = getType()
        .replace("category", "path")
        .replace("manufacturer", "manufacturer_id")
        .replace("seller", "seller_id")
        .replace("option", "option_id");
      return (
        buildLink("filter", undefined, window.innerWidth) +
        "&" +
        type +
        "=" +
        catalog_id +
        "&" +
        queryString.stringify(q_s).replaceAll("%2C", ",") +
        "&limit=" +
        limit.value +
        `${accounState.admin ? "&adm_quantity=true" : ""}`
      );
    }
  }
  // Set page
  function pageSetter(page) {
    const new_page = parseInt(page["selected"]) + 1;
    pushRoute({ page: new_page });
  }
  // Set Sort
  function sortSetter(sort) {
    setSort(sort);
    setShowSort(false);
    let val = sort["value"];
    let order = "";
    let _sort = "";
    const i_o = val.indexOf("-");
    _sort = val.substring(0, i_o);
    order = val.substring(i_o + 1);
    const obj = { sort: _sort, order: order };
    pushRoute(obj);
  }
  // Set limit
  function limitSetter(limit) {
    setLimit(limit);
    setShowLimit(false);
    pushRoute({ limit: limit.value });
  }
  // Push Route
  function pushRoute(data) {
    const q_s = queryString.parse(location.search);
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        const element = data[key];
        q_s[key] = element;
      }
    }
    history(
      "/" +
        catalog_name +
        `/${type.slice(0, 1)}=` +
        catalog_id +
        "?" +
        queryString.stringify(q_s).replaceAll("%2C", ",")
    );
  }
  // Get the route name
  function getType() {
    return type;
  }
  // Toggle filters headers
  function toggleVisibility(e) {
    const h_sender = e;
    const sender_parent = h_sender.parentNode;
    const next_filters = sender_parent.nextElementSibling;
    const icon = sender_parent.lastChild;
    const next_filters_display = next_filters.style.display;
    if (next_filters_display === "block") {
      next_filters.style.display = "none";
      icon.style.transform = "rotate(-90deg)";
    } else {
      next_filters.style.display = "block";
      icon.style.transform = "rotate(0deg)";
    }
  }
  // Toggle filters
  function toggleFilters(e) {
    const h_sender = e;
    const sender_parent = h_sender.parentNode;
    const next_filters = sender_parent.nextElementSibling;
    const next_filters_display = next_filters.style.display;
    if (next_filters_display === "block") {
      next_filters.style.display = "none";
    } else {
      next_filters.style.display = "block";
    }
  }

  function setOption(option) {
    const option_id = option["product_option_value_id"];

    var count = 0;
    var i = 0;
    while (i < images?.length) {
      if (images[i]?.product_option_value_id > 0) {
        count++;
      }

      i++;
    }

    if (
      images[1]?.product_option_value_id > 0 ||
      productData?.options[0].option_value?.length === count
    ) {
      for (const key in images) {
        if (Object.hasOwnProperty.call(images, key)) {
          const element = images[key];
          if (element["product_option_value_id"] === option_id) {
            setActiveOption(option);
          }
        }
      }
    }
    setActiveOption(option);

    // setImageActiveOption(option);
  }

  function CustomPrevArrows({ direction, onClick, style, className }) {
    return (
      <div
        style={{ ...style, padding: "2px 5px" }}
        onClick={onClick}
        className="mySwiper"
      >
        <div className="swiper-button-prev"></div>
      </div>
    );
  }

  const clearAllFilter = () => {
    history(location.pathname);
  };

  function CustomNextArrows({ direction, onClick, style, className }) {
    return (
      <div
        style={{ ...style, padding: "2px 5px" }}
        onClick={onClick}
        className="mySwiper"
      >
        <div className="swiper-button-next"></div>
      </div>
    );
  }

  const productSetting = {
    speed: 200,
    slidesToShow: 8,
    slidesToScroll: 3,
    infinite: false,
    prevArrow: <CustomPrevArrows direction={"l"} />,
    nextArrow: <CustomNextArrows direction={"r"} />,
  };
  const productMSetting = {
    speed: 200,
    slidesToShow: 3.5,
    slidesToScroll: 3,
    infinite: false,
  };

  function priceFilter(param) {
    // console.log(filterValue.start_value);
    var url = "";
    var url1 = new URL(window.location);
    var filter_price = url1.searchParams.get("filter_price");

    setUserFilters({
      ...userFilters,
      filter_price: [],
    });

    if (
      priceFrom.current.value !== "" &&
      priceTo.current.value !== "" &&
      priceFrom.current.value < priceTo.current.value &&
      filter_price === null &&
      param !== "clear"
    ) {
      setUserFilters({
        ...userFilters,
        filter_price: [priceFrom.current.value + "-" + priceTo.current.value],
      });
      if (!url1?.searchParams?.get("has_filter")) {
        url += "?has_filter=true";
      }
      if (location.pathname.indexOf("filter_price")) {
        url +=
          "&filter_price=" +
          priceFrom.current.value +
          "-" +
          priceTo.current.value;
      }
    }
    if (!url1?.searchParams?.get("has_filter")) {
      history(path + url);
    } else {
      let active_filters = {};
      for (const key in userFilters) {
        if (Object.hasOwnProperty.call(userFilters, key)) {
          const element = userFilters[key];

          if (element.length > 0 && key !== "type_key") {
            active_filters[key] = element;
          }
        }
      }
      var query = "";

      query = "?has_filter=true&";

      let q = new URLSearchParams(active_filters).toString();

      q = decodeURIComponent(q);
      query += q;

      if (param === "clear") {
        setFilterValue({ start_price: "", end_price: "" });
        priceFrom.current.value = "";
        priceTo.current.value = "";
        if (
          window.location.href.indexOf("filter_sellers") < 0 &&
          window.location.href.indexOf("filter_munufacturers") < 0 &&
          window.location.href.indexOf("filter_options") < 0 &&
          window.location.href.indexOf("filter_advs") < 0
        ) {
          history(path);
        } else {
          history(
            path +
              query.replace("&filter_price=" + filter_price, "") +
              "&last=p"
          );
        }
      } else {
        history(path + query + url);
      }
    }

    if (filter_price !== null && param !== "clear") {
      history(
        path +
          query.replace(
            "&filter_price=" + filter_price,
            "&filter_price=" +
              priceFrom.current.value +
              "-" +
              priceTo.current.value
          )
      );
    }
  }

  // Check filters
  function parseFilter(typekey, filter) {
    setTopFilter({
      show: false,
      name: "",
      offset: 0,
    });
    const id = filter["id"];
    var last = "";
    let type_key = typekey;
    // var sort="";
    // var order="";
    // var limit ='';
    last = filter["last"];

    let values_array = userFilters[type_key];
    let c;
    let indexOfId = -1;
    let url1 = new URL(window.location);
    var filter_type = typekey;
    c = url1.searchParams.get(filter_type);

    if (c !== null) {
      indexOfId = c.split(",").indexOf(filter["id"]);
    }
    if (indexOfId < 0) {
      // // console.log("Test from if");
      values_array.push(filter["id"]);

      setUserFilters({
        ...userFilters,
        type_key: values_array,
      });

      let active_filters = {};
      for (const key in userFilters) {
        if (Object.hasOwnProperty.call(userFilters, key)) {
          const element = userFilters[key];

          if (element.length > 0 && key !== "type_key") {
            active_filters[key] = element;
          }
        }
      }

      // if(url1.searchParams.get("sort")!=null){
      //   sort = "&sort=" + url1.searchParams.get("sort");
      // }
      // if(url1.searchParams.get("order")!=null){
      //   order = "&order=" + url1.searchParams.get("order");
      // }

      // if(url1.searchParams.get("limit")!=null){
      //   limit = "&limit=" + url1.searchParams.get("limit");
      // }
      let query = "?has_filter=true&";
      let q = new URLSearchParams(active_filters).toString();

      q = decodeURIComponent(q);
      query += q;

      history(path + query + "&last=" + last);
    } else {
      let query = type_key + "=" + id;
      let q = new URLSearchParams(query).toString();
      q = decodeURIComponent(q);
      // console.log("q" + q);

      // console.log("query" + query);
      let url1 = "?has_filter=false";
      values_array.pop();
      setUserFilters({
        ...userFilters,
        type_key: values_array,
      });

      if (location.search.indexOf(id) > -1) {
        let c = "";
        var array;
        let lastLink;

        url1 = new URL(window.location);
        // if(url1.searchParams.get("sort")!=null){
        //   sort = "&sort=" +url1.searchParams.get("sort");
        // }
        // if(url1.searchParams.get("order")!=null){
        //    order = "&order=" +url1.searchParams.get("order");
        // }
        // filter_type = "filter_" + type;
        c = url1.searchParams.get(filter_type);
        if (c != null) {
          array = c.split(",");
          let indexOfId = array.indexOf(id);
          let lengthArray = array.length;
          if (indexOfId >= 0) {
            lastLink = url1.searchParams.get("last");
            if (indexOfId === 0 && lengthArray === 1) {
              if (location.search.indexOf("&" + q) > 0) {
                url1 = location.search.replace("&" + q, "");
              } else {
                url1 = location.search.replace(q, "");
              }

              if (url1 === "?has_filter=true&last=" + lastLink) {
                url1 = "";
              }
              if (url1 !== "") {
                url1 = url1
                  .toString()
                  .replace("&last=" + lastLink, "&last=" + last);
              }
            } else if (indexOfId === 0 && lengthArray > 1) {
              url1 = location.search.replace(id + ",", "");
              url1 = url1
                .toString()
                .replace("&last=" + lastLink, "&last=" + last);
            } else {
              url1 = location.search.replace("," + id, "");
              url1 = url1
                .toString()
                .replace("&last=" + lastLink, "&last=" + last);
            }
          }
        }
        history(url + url1);
      } else {
        history("/" + path1);
      }
    }
  }

  // function checkFilter(type, name, filter) {
  //   location.state = {
  //     oldFilters: data && data.filters,
  //   };

  //   var url = new URL(window.location);
  //   //  console.log("type=" + name);
  //   var c = url.searchParams.get(type);

  //   // console.log(filter["id"]);
  //   let array = Array("");
  //   array[type] = c?.split(",");
  //   // console.log("ccccc" + c);

  //   // console.log("ccccc" + c);
  //   if (name === "Color" || name === "Light Color") {
  //     // console.log("omar" + filter["id"]);
  //     if (c !== null && array[type].includes(filter["id"]) === true) {
  //       return "rounded-full border border-dblue";
  //     } else {
  //       return "rounded-full border relative border-dgreyRate cursor-pointer hover:shadow";
  //     }
  //   } else if (
  //     name === "Shoes Size" ||
  //     name === "Size by Age" ||
  //     name === "jeans Size" ||
  //     name === "Socks"
  //   ) {
  //     if (c !== null && array[type].includes(filter["id"]) === true) {
  //       return "border rounded text-dblue border-dblue p-2";
  //     } else {
  //       return "border rounded relative border-dgreyRate cursor-pointer hover:shadow p-2";
  //     }
  //   } else {
  //     if (c !== null && array[type].includes(filter["id"]) === true) {
  //       return "icon-ok-squared text-dblue";
  //     } else {
  //       return "icon-check-empty";
  //     }
  //   }
  // }

  //export products pdf for flo
  useEffect(() => {

    if (exportProduct) {
      setLoadingExport(true);
      const url =
        parseUrl(false, true) +
        `&export_all=true&user_id=${Cookies.get("user_id")}`;

      _axios.get(url).then((response) => {
        if (!response.data?.success) {
          setErrPermission(response?.data?.message);
          setLoadingExport(false);
          setExportProduct(false);
          setTimeout(() => {
            setErrPermission("");
          }, 4000);
          return;
        }

        if (response.data.error || response.data.breadcrumbs?.length === 0) {
          setEmpty(true);
          setData(response.data);
          setLoadingProducts(false);
          setNoDataNoError(true);
          loadingContext.done();
          setLoadingExport(false);
          setExportProduct(false);
          return;
        }

        const is_filter = window.location.href.indexOf("has_filter") > 0;
        let data;
        if (is_filter) {
          data = response.data.data;
        } else {
          data = response.data.data;
        }

       
     
        const products_arr = response?.data?.data?.products;
    

        const productsPerPage = 1500; // You can adjust this value based on your requirements
        const totalPages = Math.ceil(products_arr.length / productsPerPage);
        generatePDF(products_arr, 1, totalPages);
      });
    }
  }, [exportProduct]);

  const generatePDF = (products, currentPage, totalPages) => {
    const pdf_export = new JsPDF("landscape", "pt", "a4");

    let productsPerPage = 1500;

    const startIndex = (currentPage - 1) * productsPerPage;
    const endIndex = Math.min(startIndex + productsPerPage, products.length);
    const pageData = products.slice(startIndex, endIndex);

    const pageDiv = document.createElement("div");
    pageDiv.id = "temp-page-div";
    pageDiv.style.display = "grid";
    pageDiv.style.width = "70%";
    pageDiv.style.marginLeft = "10px";
    pageDiv.style.gridTemplateColumns = "1fr 1fr"; // Two columns for each row
    document.body.appendChild(pageDiv);

    pageData.forEach((product) => {
      const productColumn = document.createElement("div");
      productColumn.className = "grid-column";

      const singleProduct = (
        <SingleProductExport
          item={product}
          style={{ width: "100%", maxWidth: "100%" }}
        ></SingleProductExport>
      );
      ReactDOM.render(singleProduct, productColumn);
      pageDiv.appendChild(productColumn);
    });

    pdf_export.html(pageDiv).then(() => {
      pdf_export.save(`products_page_${currentPage}.pdf`);

      document.body.removeChild(pageDiv);

      if (currentPage < totalPages) {
        generatePDF(products, currentPage + 1, totalPages);
      } else {
        // All pages have been generated, so finish the export process
        setLoadingExport(false);
        setExportProduct(false);
      }
    });
  };

  const scrollRef = useRef(null);

  const scroll = (direction) => {
    const container = scrollRef.current;
    const scrollAmount = 200;
    if (direction === "left") {
      container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    } else {
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  const handleMouseMove = (e) => {
    const container = scrollRef.current;
    const { left, width } = container.getBoundingClientRect();
    const mouseX = e.clientX - left;
    const percent = mouseX / width;
    const scrollAmount = container.scrollWidth - width;

    container.scrollLeft = scrollAmount * percent;
  };

  const scrollRefMobile = useRef(null);

  const handleMobileMouseMove = (e) => {
    const container = scrollRefMobile.current;
    const { left, width } = container.getBoundingClientRect();
    const mouseX = e.clientX - left;
    const percent = mouseX / width;
    const scrollAmount = container.scrollWidth - width;

    container.scrollLeft = scrollAmount * percent;
  };

  if (
    (data?.products?.length < 1 && data?.widgets?.length < 1) ||
    data?.error ||
    noDataNoError
  ) {
    return (
      <div className="flex items-center justify-center mt-20 pb-5 flex-col">
        <img src={notFound} className=" w-2/12" alt="Not Found" />
        <h2 className="text-2xl mt-4">Sorry, there is nothing here!</h2>
        <Link
          to={`${path}/`}
          className="bg-dblue text-white px-10 py-3 rounded mt-4"
        >
          START SHOPPING
        </Link>
        <button
          onClick={() => history(-1)}
          className="bg-dbase text-white px-10 py-3 rounded mt-4"
        >
          Go back
        </button>
      </div>
    );
  } else {
    return (
      <div className="w-full h-full bg-dinputBorder">
        {showRedirectModal && <RedirectModal setClicked={setClicked} />}

        {width < 650 && (
          <ScrollToTop
            smooth
            className="rounded-full  bg-dgreyBlack text-white text-center opacity-70"
            width="36"
            height="30"
            color="white"
            top="1000"
            style={{ width: "50px", height: "50px", padding: "7px" }}
          />
        )}
        <div
          className="sm:container h-full pt-2 pb-2"
          style={{
            backgroundColor: "#f7f7fa",
          }}
        >
          {loading ? (
            <>
            
                {width > 650 ? (
                  <CatalogPlaceholder />
                ) : (
                  <CatalogMobilePlaceholder />
                
              )}
           :
              
            </>
          ) : (
            <div>
            {
              <div className=" hidden xl:flex lg:flex pt-2 pb-2  items-center text-xs  text-dgrey1">
                <div className="flex items-center">
                  <Link
                    to="/"
                    className="hidden md:block text-dblack font-light truncate text-d11 md:text-tiny mr-2 hover:text-dblue"
                    dangerouslySetInnerHTML={{
                      __html: "Home",
                    }}
                  />{" "}
                  <i className="icon icon-angle-right"></i>
                </div>
                {data?.breadcrumbs?.map((bread) => (
                  <div className="flex items-center" key={bread.text}>
                    <p className=" mx-2">
                      {bread.text.replace("&amp;", "&")}
                    </p>
                  </div>
                ))}
              </div>
            }
            <SeoHandler
              data={{
                title: data?.heading_title,
                description: data?.meta?.meta_description,
                keyword: data?.meta?.meta_keyword,
                // tag: data.meta.meta_tags,
              }}
            />
            <div className="flex text-dblack ">
     
              <div className="relative w-2/12 p-5 hidden xl:block lg:block  h-screen pb-5 mobile:pr-5 mobile:pl-5">
                {window.location.href.indexOf("has_filter") > 0 && (
                  <div
                    onClick={clearAllFilter}
                    className="w-full flex items-center justify-center text-[14px] text-black cursor-pointer py-2 px-4 mt-2"
                  >
                    <FaRegTrashAlt className="mr-2" />{" "}
                    {/* Add trash icon with margin */}
                    Clear All Filters
                  </div>
                )}

                {filter_product &&
                  Object.keys(filter_product).map((key) =>
                    filter_product[key].id === "filter_categories" &&
                    data?.categories?.length === 0 ? (
                      <></>
                    ) : (
                      <div key={key}>
                        {filter_product[key].items.length > 0 && (
                          <div>
                            <h1
                              className="
                              capitalize
                              mb-3
                              mt-1
                              text-base
                              font-semibold
                              text-dblack
                              flex
                              items-center
                              justify-between
                              cursor-pointer
                              hover:opacity-80
                              relative
                            "
                              onClick={(e) =>
                                toggleVisibility(e.target)
                              }
                            >
                              <div className="absolute w-full h-full"></div>
                              <span>{filter_product[key].name}</span>
                              <i className="icon icon-angle-down text-dgrey1 text-2xl transition-all"></i>
                            </h1>

                            <div style={{ display: "block" }}>
                              {filter_product[key].id ===
                                "filter_categories" && data?.categories
                                ? (data?.categories?.length > 5
                                    ? data?.categories?.slice(0, 5)
                                    : data?.categories
                                  ).map((category) => (
                                    <div key={Math.random()}>
                                      {
                                        <Link
                                          to={`${path}/${
                                            category.name
                                              .replace(
                                                /\s+&amp;\s+|\s+&gt;/g,
                                                "-"
                                              )
                                              .replace(/\s+/g, "-")
                                              .replaceAll("/", "-") +
                                            "/c=" +
                                            category.id
                                          }`}
                                        >
                                          <p className="flex gap-2 flex-wrap md:text-[12px] lg:text-[16px] hover:text-dblue hover:cursor-pointer">
                                            <i>
                                              {checkFilter(
                                                filter_product[key].id,
                                                category.name,
                                                {
                                                  id: category.id,
                                                  last: "c",
                                                }
                                              )}
                                            </i>
                                            <span className="text-d13 font-light">
                                              {decodeHtml(
                                                category.name
                                              )}
                                            </span>
                                          </p>
                                        </Link>
                                      }
                                    </div>
                                  ))
                                : filter_product[key].items
                                    .slice(0, 5)
                                    .map((filter) => (
                                      <div key={Math.random()}>
                                        {filter_product[key].name ===
                                          "Light Color" ||
                                        (filter_product[key].name ===
                                          "Color" &&
                                          filter_product[key]
                                            .option_id) ? (
                                          <p
                                            className="my-2 flex items-center cursor-pointer hover:text-dblue"
                                            onClick={() =>
                                              parseFilter(
                                                filter_product[key].id,
                                                filter
                                              )
                                            }
                                          >
                                            <span className="flex w-10/12">
                                              <span
                                                className={`flex w-7 h-7 ${checkFilter(
                                                  filter_product[key]
                                                    .id,
                                                  filter_product[key]
                                                    .name,
                                                  filter
                                                )}`}
                                              >
                                                <img
                                                  src={filter.image}
                                                  style={{
                                                    padding: `1px`,
                                                  }}
                                                  className={`w-12/12 rounded-full border border-dgreyRate`}
                                                  alt="Not Found"
                                                />
                                              </span>
                                              <p className="py-2 mx-2 text-d13 w-8/12 font-light">
                                                {decodeHtml(
                                                  filter.name
                                                )}
                                              </p>
                                            </span>
                                            <span className="flex w-1/12"></span>
                                            <span className="text-d13 text-right font-light">
                                              ({filter.count})
                                            </span>
                                          </p>
                                        ) : (
                                          <div>
                                            <p
                                              className="flex gap-2 flex-wrap md:text-[12px] lg:text-[16px] hover:text-dblue hover:cursor-pointer"
                                              onClick={() =>
                                                parseFilter(
                                                  filter_product[key]
                                                    .id,
                                                  filter
                                                )
                                              }
                                            >
                                              <i>
                                                {checkFilter(
                                                  filter_product[key]
                                                    .id,
                                                  filter.name,
                                                  filter
                                                )}
                                              </i>
                                              <span className="text-d13 font-light">
                                                {decodeHtml(
                                                  filter.name
                                                )}
                                              </span>

                                              <span className="float-right text-d13 font-light">
                                                ({filter.count})
                                              </span>
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                    ))}
                              {filter_product[key].items.length > 5 && (
                         
                                    <div>
                                      <label
                                        className="text-dblue text-sm font-semibold underline cursor-pointer"
                                        onClick={() => {
                                          openOverlay(key);
                                        }}
                                      >
                                        See All
                                      </label>
                                    </div>
                                  )}
                            </div>
                          </div>
                        )}
                      </div>
                    )
                  )}
              </div>

              {/* Overlay */}
              {isOverlayOpen && (
                <div
                  className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
                  onClick={closeOverlay}
                >
                  <div
                    className="flex flex-col px-6 modal w-[400px] h-[350px] md:w-[550px] md:h-[400px] xl:w-[800px] xl:h-[500px] p-x-4 p-y-2 relative bg-white shadow-custom-gray mr-96"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      className="absolute top-4 right-2 text-dblack"
                      onClick={closeOverlay}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="w-5 h-5"
                      >
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                      </svg>
                    </button>

                    <div className="flex w-full items-center pt-6 pb-2 z-50">
                      <input
                        ref={inputRef}
                        className="w-1/2 border-[1px] outline-none py-1 pl-2"
                        type="text"
                        placeholder={`Search ${filter_product[currentFilter].name}`}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                      <div className="h-full flex items-center justify-center px-2 cursor-pointer rounded-r-md bg-dblack">
                        <IoMdSearch
                          size={25}
                          color={"white"}
                          className="my-auto"
                          onClick={handleSearch}
                        />
                      </div>
                    </div>

                    <div className="flex justify-between items-center mb-4">
                      <h1 className="flex justify-start font-bold text-[26px] mb-2">
                        {filter_product[currentFilter].name}
                      </h1>
                    </div>

                    {/* Scrollable Content */}

                    <div className="overflow-auto h-[calc(100%-80px)]">
                      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-y-6">
                        {(filter_product[currentFilter].id ===
                        "filter_categories"
                          ? data?.categories
                          : filter_product[currentFilter].items
                        ).map((item) => (
                          <div
                            className="flex gap-2 flex-wrap md:text-[12px] lg:text-[16px]"
                            key={item.id}
                          >
                            {filter_product[currentFilter].name ===
                              "Color" &&
                            filter_product[currentFilter].option_id ? (
                              <div
                                className="flex items-center cursor-pointer hover:text-dblue"
                                onClick={() =>
                                  handleCheckboxClick(item.id)
                                }
                              >
                                <span
                                  className={`flex w-[1.75rem] h-18 border ${
                                    borderColors[item.id] ||
                                    "border-dgreyRate"
                                  }`}
                                >
                                  <img
                                    src={item.image}
                                    width="28"
                                    height="28"
                                    className="w-12/12 rounded-full border border-dgreyRate"
                                    alt=""
                                  />
                                </span>
                              </div>
                            ) : filter_product[currentFilter].id ===
                              "filter_categories" ? (
                              <Link
                                to={`${path}/${
                                  item.name
                                    .replace(
                                      /\s+&amp;\s+|\s+&gt;/g,
                                      "-"
                                    )
                                    .replace(/\s+/g, "-")
                                    .replaceAll("/", "-") +
                                  "/c=" +
                                  item.id
                                }`}
                              >
                                <p className="flex gap-2 flex-wrap md:text-[12px] lg:text-[16px] hover:text-dblue hover:cursor-pointer">
                                  <i>
                                    {checkFilter(
                                      filter_product[currentFilter].id,
                                      item.name,
                                      {
                                        id: item.id,
                                        last: "c",
                                      }
                                    )}
                                  </i>
                                  <span className="text-d13 font-light">
                                    {decodeHtml(item.name)}
                                  </span>
                                </p>
                              </Link>
                            ) : (
                              <FilterItem
                                type={filter_product[currentFilter].id}
                                item={item}
                                onClick={(id) => {
                                  handleCheckboxClick(id);
                                }}
                              />
                            )}
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="flex justify-end mt-4">
                      <button
                        className="px-8 py-2 bg-dblue1 text-white rounded-md mr-4 mb-6 font-semibold"
                        onClick={() =>
                          parseFilter1(
                            filter_product[currentFilter].id,
                            selectedIdsRef.current
                          )
                        }
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {successAdded && (
                <div
                  className="fixed w-screen h-full min-h-screen top-0 left-0  bg-opacity-30 bg-dblack z-30"
                  onClick={() => setSuccessAdded(false)}
                ></div>
              )}

              <div
                className={`${width < 650 && "hidden"}`}
                onClick={() => setSuccessAdded(false)}
              >
                <div
                  className={`${
                    width < 650 && "hidden"
                  } top-0  bg-white right-0 w-3/12 px-4 min-h-screen transform   fixed h-full z-40  ease-in-out duration-300 ${
                    successAdded ? "translate-x-0 " : "translate-x-full"
                  }`}
                >
                  <div>
                    <div className=" border-b border-dinputBorder py-2">
                      <div className="flex ">
                        <img
                          src={productData.thumb}
                          alt={productData.name}
                          className=" w-4/12 rounded"
                        />
                        <div className="mt-2 pl-4 py-2">
                          <p
                            className="text-xs font-semibold "
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                productData.name
                              ),
                            }}
                          />
                          {hasBannerEvent?.name !== undefined &&
                          hasBannerEvent?.name !== "" ? (
                            <p
                              className="text-xs font-semibold "
                              dangerouslySetInnerHTML={{
                                __html:
                                  hasBannerEvent?.name +
                                  " - " +
                                  productData?.name?.toUpperCase(),
                              }}
                            />
                          ) : (
                            <p
                              className="text-xs font-semibold "
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                  productData?.name?.toUpperCase()
                                ),
                              }}
                            />
                          )}
                          <p className="text-xs font-semibold mt-2 text-dgreen">
                            Added To Cart
                          </p>
                        </div>
                      </div>

                      <div className="flex justify-between items-center  mt-2 mb-2">
                        <Link
                          to={`${path}/cart/`}
                          className="text-center text-xs bg-dblue border border-dblue rounded text-white py-2 px-2 flex-grow mr-2 hover:bg-dbluedark"
                        >
                          CHECKOUT
                        </Link>
                        <button
                          onClick={() => setSuccessAdded(false)}
                          className=" border text-xs border-dblue rounded text-dblue py-2 flex-grow ml-2 hover:bg-dblue hover:text-white"
                        >
                          CONTINUE SHOPPING
                        </button>
                      </div>
                    </div>

                    <h2 className="my-4 font-semibold text-dblack text-xl">
                      Basket
                    </h2>
                    {state.products?.map((product) => (
                      <div className="flex border-b border-dinputBorder py-2">
                        <img
                          src={product.thumb}
                          alt={product.name}
                          className=" w-3/12 rounded"
                        />
                        <div className="flex flex-col items-start justify-between pl-4 py-2">
                          <p
                            className=" text-sm font-light"
                            dangerouslySetInnerHTML={{
                              __html:
                                product.name.substring(0, 75) +
                                (product.name.length > 75 && "..."),
                            }}
                          />
                          <p className="font-semibold">
                            {product.total + " "} ( {product.quantity}{" "}
                            item
                            {product.quantity > 1 && <span>s</span>} )
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Products */}
              <div className="w-full xl:w-10/12 lg:w-10/12">
                <div className="block xl:flex lg:flex justify-between  pb-2 items-center">
                  {/* Results found */}
                  <div className=" pb-4 xl:pb-0 lg:pb-0 flex mx-1">
                    <span className=" mr-1 font-light">
                      {data?.product_total} Results{" "}
                      {data?.heading_title && "for"}
                    </span>
                    {data?.heading_title && '"'}
                    <h1
                      className="font-semibold capitalize"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(data?.heading_title),
                      }}
                    />
                    {data?.heading_title && '"'}
                  </div>
                  {/* Settings */}
                  {/* Desktop setting */}
                  <div className="hidden xl:flex lg:flex">
                    {/* Sorts */}
                    {data?.products?.length > 0 && (
                      <div className=" px-8 flex items-center">
                        <span className=" text-xs font-semibold text-dgrey1">
                          SORT BY
                        </span>
                        <div className="relative">
                          <button
                            className="bg-white px-8 py-1 ml-4 border text-sm font-semibold cursor-pointer rounded flex items-start"
                            onClick={() => setShowSort(!showSort)}
                          >
                            <span>
                              {
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(
                                      sort.text
                                    ),
                                  }}
                                ></span>
                              }
                            </span>
                            <i
                              className={`block icon icon-angle-down ml-2 transition-all ${
                                showSort && "transform  rotate-180"
                              }`}
                            ></i>
                          </button>
                          {showSort && (
                            <div
                              className="bg-white py-4 w-44 shadow-2xl absolute z-40 right-0 top-9"
                              ref={sortRef}
                            >
                              {data?.sorts?.map((sort) => (
                                <span
                                  onClick={() => {
                                    sortSetter(sort);
                                  }}
                                  className=" block text-sm font-light px-4 py-2 cursor-pointer hover:bg-dblue hover:text-white"
                                  key={sort.value}
                                  dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(
                                      sort.text
                                    ),
                                  }}
                                ></span>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    {/* Per Page */}
                    {data?.products?.length > 0 && (
                      <div className=" px-8 flex items-center">
                        <span className=" text-xs font-semibold text-dgrey1">
                          DISPLAY
                        </span>
                        <div className="relative">
                          <button
                            className="bg-white px-8 py-1 ml-4 border text-sm font-semibold cursor-pointer rounded flex items-start"
                            onClick={() => setShowLimit(!showLimit)}
                          >
                            <span>
                              {
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(
                                      limit.text
                                    ),
                                  }}
                                ></span>
                              }
                            </span>
                            <i
                              className={`block icon icon-angle-down ml-2 transition-all ${
                                showLimit && "transform  rotate-180"
                              }`}
                            ></i>
                          </button>
                          {showLimit && (
                            <div
                              className="bg-white py-4 w-44 shadow-2xl absolute z-40 right-0 top-9"
                              ref={limitRef}
                            >
                              {data?.limits?.map((limit) => (
                                <span
                                  onClick={() => limitSetter(limit)}
                                  className=" block text-sm font-light px-4 py-2 cursor-pointer hover:bg-dblue hover:text-white"
                                  key={limit.value}
                                  dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(
                                      limit.text
                                    ),
                                  }}
                                ></span>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    {/* Display GRID OR LIST */}
                    {data?.products?.length > 0 && (
                      <div className="flex items-center">
                        <span className=" text-xs font-semibold text-dgrey1">
                          {productDisplay === "grid" ? "Grid" : "List"}
                        </span>
                        <button
                          className={`bg-white ml-4 text-lg border rounded block icon  transition-all ${
                            productDisplay === "grid"
                              ? "icon-th-list"
                              : "icon-th-thumb-empty"
                          }`}
                          onClick={() =>
                            setProductDisplay(
                              productDisplay === "grid"
                                ? "list"
                                : "grid"
                            )
                          }
                          style={{ width: "30px", height: "30px" }}
                        ></button>
                      </div>
                    )}
                  </div>
                  {/* Mobile Setting */}
                  <div className="block xl:hidden lg:hidden">
                    {/* Mobile sorts */}
                    {mobileSort && (
                      <div
                        onClick={() => showMobileSort(false)}
                        className="bg-dblack bg-opacity-20 z-50 w-screen h-screen fixed top-0 left-0 flex justify-end"
                      >
                        <div className="bg-white w-3/5 p-2">
                          {data?.sorts?.map((_sort) => (
                            <button
                              className="flex items-center justify-between  w-full"
                              onClick={() => sortSetter(_sort)}
                              key={_sort.value}
                            >
                              <span
                                className=" block text-sm font-light px-4 py-2 cursor-pointer hover:bg-dblue hover:text-white"
                                key={_sort.value}
                                dangerouslySetInnerHTML={{
                                  __html: DOMPurify.sanitize(
                                    _sort.text
                                  ),
                                }}
                              ></span>

                              <i
                                className={`icon ${
                                  sort.value === _sort.value
                                    ? "icon-ok text-dblue"
                                    : "icon-check-empty text-dgrey1"
                                }`}
                              ></i>
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                    {/* Mobile filters */}

                    {mobileFilter && (
                      <div className="bg-dblack bg-opacity-20 w-screen z-50 min-h-screen fixed top-0 left-0 bottom-0 right-0 overflow-y-scroll">
                        <div className="bg-white min-h-screen pb-12">
                          <h2 className="px-2 text-xl border-b py-2 border-dinputBorder font-semibold flex items-center justify-between">
                            <span>Filter</span>
                            <button
                              onClick={() => showMobileFilter(false)}
                            >
                              <i className="icon icon-cancel text-2xl"></i>
                            </button>
                          </h2>
                          {/* Filters */}
                          <div className="px-2">
                            {filter_product &&
                              Object.keys(filter_product).map((key) => (
                                <div key={key}>
                                  {filter_product[key].items.length >
                                  0 ? (
                                    <h1
                                      className="capitalize mb-3 mt-1 text-base font-semibold text-dblack flex items-center justify-between cursor-pointer hover:opacity-80 relative"
                                      onClick={(e) =>
                                        toggleVisibility(e.target)
                                      }
                                    >
                                      <div className="absolute w-full h-full"></div>
                                      <span>
                                        {filter_product[key].name}
                                      </span>
                                      <i className="icon icon-angle-down text-dgrey1 text-2xl transition-all"></i>
                                    </h1>
                                  ) : (
                                    ""
                                  )}
                                  <div style={{ display: "block" }}>
                                    {key &&
                                    filter_product[key].items.length >
                                      0 ? (
                                      <div>
                                        {filter_product[key].id ===
                                          "filter_categories" &&
                                        data?.categories
                                          ? (data?.categories?.length > 5
                                              ? data?.categories?.slice(
                                                  0,
                                                  5
                                                )
                                              : data?.categories
                                            ).map((category) => (
                                              <div key={Math.random()}>
                                                {
                                                  <Link
                                                    to={`${path}/${
                                                      category.name
                                                        .replace(
                                                          /\s+&amp;\s+|\s+&gt;/g,
                                                          "-"
                                                        )
                                                        .replace(
                                                          /\s+/g,
                                                          "-"
                                                        )
                                                        .replaceAll(
                                                          "/",
                                                          "-"
                                                        ) +
                                                      "/c=" +
                                                      category.id
                                                    }`}
                                                  >
                                                    <p className="flex gap-2 flex-wrap md:text-[12px] lg:text-[16px] hover:text-dblue hover:cursor-pointer">
                                                      <i
                                                        className={`icon mr-1 text-base  ${checkFilter(
                                                          filter_product[
                                                            key
                                                          ].id,
                                                          category.name,
                                                          {
                                                            id: category.id,
                                                            last: "c",
                                                          }
                                                        )}`}
                                                      ></i>
                                                      <span className="text-d13 font-light">
                                                        {decodeHtml(
                                                          category.name
                                                        )}
                                                      </span>
                                                    </p>
                                                  </Link>
                                                }
                                              </div>
                                            ))
                                          : filter_product[key].items
                                              .slice(0, 5)
                                              .map((filter) => (
                                                <div
                                                  key={Math.random()}
                                                >
                                                  {filter_product[key]
                                                    .name ===
                                                    "Light Color" ||
                                                  (filter_product[key]
                                                    .name === "Color" &&
                                                    filter_product[key]
                                                      .option_id) ? (
                                                    <p
                                                      className="my-2 flex items-center cursor-pointer hover:text-dblue"
                                                      key={filter.name}
                                                      onClick={() =>
                                                        parseFilter(
                                                          filter_product[
                                                            key
                                                          ].id,
                                                          filter
                                                        )
                                                      }
                                                    >
                                                      <span className="flex w-10/12">
                                                        <span
                                                          className={`flex w-7 h-7 ${checkFilter(
                                                            filter_product[
                                                              key
                                                            ].id,
                                                            filter_product[
                                                              key
                                                            ].name,
                                                            filter
                                                          )}`}
                                                        >
                                                          <img
                                                            src={
                                                              filter.image
                                                            }
                                                            style={{
                                                              padding: `1px`,
                                                            }}
                                                            className={`w-12/12 rounded-full border border-dgreyRate`}
                                                            alt="Not Found"
                                                          />
                                                        </span>
                                                        <p className="py-2 mx-2 text-d13 w-8/12 font-light">
                                                          {filter.name}
                                                        </p>
                                                      </span>
                                                      <span className="flex w-10/12"></span>
                                                      <span className="text-d13 text-right font-light ">
                                                        ({filter.count})
                                                      </span>
                                                    </p>
                                                  ) : (
                                                    <div>
                                                      <p
                                                        className="flex gap-2 flex-wrap md:text-[12px] lg:text-[16px]"
                                                        key={
                                                          filter.name
                                                        }
                                                        onClick={() =>
                                                          parseFilter(
                                                            filter_product[
                                                              key
                                                            ].id,
                                                            filter
                                                          )
                                                        }
                                                      >
                                                        <i
                                                          className={`icon mr-1 text-base  ${checkFilter(
                                                            filter_product[
                                                              key
                                                            ].id,
                                                            filter.name,
                                                            filter
                                                          )}`}
                                                        ></i>
                                                        <span className="text-d13 font-light">
                                                          {filter.name}
                                                        </span>

                                                        <span className="float-right text-d13 font-light">
                                                          (
                                                          {filter.count}
                                                          )
                                                        </span>
                                                      </p>
                                                    </div>
                                                  )}
                                                </div>
                                              ))}
                                        <div>
                                          <label
                                            className={
                                              filter_product[key].items
                                                .length > 5 ||
                                              (filter_product[key]
                                                .id ===
                                                "filter_categories" &&
                                                data?.categories
                                                  .length > 5)
                                                ? `text-dblue text-xs cursor-pointer`
                                                : "hidden"
                                            }
                                            onClick={(e) =>
                                              toggleFilters(e.target)
                                            }
                                          >
                                            Show More
                                          </label>
                                        </div>
                                        <div
                                          style={{ display: "none" }}
                                        >
                                          {filter_product[key].id ===
                                            "filter_categories" &&
                                          data?.categories
                                            ? data?.categories
                                                .slice(
                                                  5,
                                                  data?.categories
                                                    .length
                                                )
                                                .map((category) => (
                                                  <div
                                                    key={Math.random()}
                                                  >
                                                    {
                                                      <Link
                                                        to={`${path}/${
                                                          category.name
                                                            .replace(
                                                              /\s+&amp;\s+|\s+&gt;/g,
                                                              "-"
                                                            )
                                                            .replace(
                                                              /\s+/g,
                                                              "-"
                                                            )
                                                            .replaceAll(
                                                              "/",
                                                              "-"
                                                            ) +
                                                          "/c=" +
                                                          category.id
                                                        }`}
                                                      >
                                                        <p className="flex gap-2 flex-wrap md:text-[12px] lg:text-[16px] hover:text-dblue hover:cursor-pointer">
                                                          <i
                                                            className={`icon mr-1 text-base  ${checkFilter(
                                                              filter_product[
                                                                key
                                                              ].id,
                                                              category.name,
                                                              {
                                                                id: category.id,
                                                                last: "c",
                                                              }
                                                            )}`}
                                                          ></i>
                                                          <span className="text-d13 font-light">
                                                            {decodeHtml(
                                                              category.name
                                                            )}
                                                          </span>
                                                        </p>
                                                      </Link>
                                                    }
                                                  </div>
                                                ))
                                            : filter_product[key].items
                                                .slice(
                                                  5,
                                                  filter_product[key]
                                                    .items.length
                                                )
                                                .map((filter) => (
                                                  <div
                                                    key={Math.random()}
                                                  >
                                                    {filter_product[key]
                                                      .name ===
                                                      "Light Color" ||
                                                    filter_product[key]
                                                      .name ===
                                                      "Color" ? (
                                                      <p
                                                        className="my-2 flex items-center cursor-pointer hover:text-dblue"
                                                        key={
                                                          filter.name
                                                        }
                                                        onClick={() =>
                                                          parseFilter(
                                                            filter_product[
                                                              key
                                                            ].id,
                                                            filter
                                                          )
                                                        }
                                                      >
                                                        <span className="flex w-10/12">
                                                          <span
                                                            className={`flex w-7 h-7 ${checkFilter(
                                                              filter_product[
                                                                key
                                                              ].id,
                                                              filter_product[
                                                                key
                                                              ].name,
                                                              filter
                                                            )}`}
                                                          >
                                                            <img
                                                              src={
                                                                filter.image
                                                              }
                                                              style={{
                                                                padding: `1px`,
                                                              }}
                                                              className={`w-12/12 rounded-full border border-dgreyRate`}
                                                              alt="Not Found"
                                                            />
                                                          </span>
                                                          <p className="py-2 mx-2 text-d13 w-8/12 font-light">
                                                            {
                                                              filter.name
                                                            }
                                                          </p>
                                                        </span>
                                                        <span className="flex w-1/12"></span>
                                                        <span className="text-d13 text-right font-light ">
                                                          (
                                                          {filter.count}
                                                          )
                                                        </span>
                                                      </p>
                                                    ) : (
                                                      <div>
                                                        <p
                                                          className="flex gap-2 flex-wrap md:text-[12px] lg:text-[16px]"
                                                          key={
                                                            filter.name
                                                          }
                                                          onClick={() =>
                                                            parseFilter(
                                                              filter_product[
                                                                key
                                                              ].id,
                                                              filter
                                                            )
                                                          }
                                                        >
                                                          <i
                                                            className={`icon mr-1 text-base  ${checkFilter(
                                                              filter_product[
                                                                key
                                                              ].id,
                                                              filter.name,
                                                              filter
                                                            )}`}
                                                          ></i>
                                                          <span className="text-d13 font-light">
                                                            {
                                                              filter.name
                                                            }
                                                          </span>

                                                          <span className="float-right text-d13 font-light">
                                                            (
                                                            {
                                                              filter.count
                                                            }
                                                            )
                                                          </span>
                                                        </p>
                                                      </div>
                                                    )}
                                                  </div>
                                                ))}
                                        </div>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              ))}
                          </div>
                          {/* End Filters */}
                        </div>
                      </div>
                    )}

                    {/* End mobile filters */}
                    <div className="w-screen bg-white -mx-4">
                      <div className="grid grid-cols-2 divide-x divide-dinputBorder bg-white py-2 rounded">
                        <button onClick={() => showMobileFilter(true)}>
                          <span>Filter</span>
                          <i className="icon icon-filter ml-1"></i>
                        </button>
                        {data?.products?.length > 0 && (
                          <button onClick={() => showMobileSort(true)}>
                            <span>Sort By</span>
                            <i className="icon icon-sort ml-1"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {data?.categories?.length > 0 &&
                  data?.sub_category_status === "1" && (
                    <div>
                      {/* Desktop Categories */}
                      <div className="relative hidden lg:block w-full mt-3 mb-2">
                        <button
                          onClick={() => scroll("left")}
                          className="absolute left-0 top-1/2 -translate-y-1/2 z-10 p-2 bg-white shadow-md rounded-full"
                        >
                          <FaChevronLeft />
                        </button>
                        <div
                          className="overflow-x-auto mx-4 bg-white mr-4"
                          ref={scrollRef}
                          onMouseMove={handleMouseMove}
                          style={{
                            whiteSpace: "nowrap",
                            cursor: "pointer",
                            scrollbarWidth: "none",
                            msOverflowStyle: "none",
                          }}
                        >
                          {data?.categories?.map((category) => (
                            <Link
                              key={category.id}
                              to={
                                // state.admin

                                //   ? `${path}/category/${category.id}`
                                //   :
                                `${path}/${
                                  category.name
                                    .replace(
                                      /\s+&amp;\s+|\s+&gt;/g,
                                      "-"
                                    )
                                    .replace(/\s+/g, "-")
                                    .replaceAll("/", "-") +
                                  "/c=" +
                                  category.id
                                }`
                              }
                              state={{
                                source_type: getType(),
                                source_type_id: catalog_id,
                              }}
                              className="inline-flex w-36 text-center  p-2 items-center justify-center flex-col   hover:opacity-80 mb-1"
                            >
                              <LazyLoadImage
                                alt={category.name}
                                src={category.thumb}
                                className="h-20"
                                placeholdersrc="https://ishtari.com/static/product_placeholder_square.png"
                              />
                              <h2
                                dangerouslySetInnerHTML={{
                                  __html: sanitizeHTML(category.name),
                                }}
                                className="text-xs xl:text-xs lg:text-xs w-full font-medium xl:font-semibold lg:font-semibold mt-2 overflow-hidden"
                                style={{
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                  lineHeight: "1.2rem",
                                  minHeight: "2.4rem",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                }}
                              ></h2>
                            </Link>
                          ))}
                        </div>

                        <button
                          onClick={() => scroll("right")}
                          className="absolute right-0 top-1/2 -translate-y-1/2 z-10 p-2 bg-white shadow-md rounded-full"
                        >
                          <FaChevronRight />
                        </button>
                      </div>
                      {/* Mobile Categories */}
                      <div className="block xl:hidden lg:hidden w-screen bg-white -mx-4 mb-2">
                        <Slider {...productMSetting}>
                          {data.categories.map((category) => (
                            <Link
                              key={category.id}
                              to={
                                // state.admin
                                //   ? `${path}/category/${category.id}`
                                //   :
                                `${path}/${
                                  category.name
                                    .replace(
                                      /\s+&amp;\s+|\s+&gt;/g,
                                      "-"
                                    )
                                    .replace(/\s+/g, "-")
                                    .replaceAll("/", "-") +
                                  "/c=" +
                                  category.id
                                }`
                              }
                              className="inline-flex w-24 xl:w-28 lg:w-28 text-center  items-center justify-center flex-col p-2 mx-2 hover:opacity-80 mb-1"
                            >
                              <LazyLoadImage
                                alt={category.name}
                                src={category.thumb}
                                width={110}
                                height={110}
                                placeholdersrc="https://ishtari.com/static/product_placeholder_square.png"
                                className="h-20 w-20"
                              />
                              <h2
                                dangerouslySetInnerHTML={{
                                  __html: DOMPurify.sanitize(
                                    category.name
                                  ),
                                }}
                                className="text-xs xl:text-xs lg:text-xs w-full font-medium xl:font-semibold lg:font-semibold mt-2 line-clamp-2"
                              ></h2>
                            </Link>
                          ))}
                        </Slider>
                      </div>
                    </div>
                  )}
                  {width > 650 ? (
                      <div>{DesktopWidgetsList}</div>

                  ) : (
                    <div>
                    {MobileWidgetsList}
                    {WidgetsList}
                  </div>

                  )}
        

                    {Loading && <PointsLoader />}
                    
                    {loadingProducts && <PointsLoader />}
              
                <div
                  className={`grid transition-all ${
                    productDisplay === "grid"
                      ? !filter_product ||
                        (filter_product &&
                          Object.keys(filter_product)?.length < 1)
                        ? "grid-cols-2 xl:grid-cols-6 lg:grid-cols-6"
                        : "grid-cols-2 xl:grid-cols-5 lg:grid-cols-5 mobile:pt-2"
                      : "grid-cols-1"
                  }`}
                >
                  {data?.product_list_status !== "0" &&
                    data?.products?.map((product) => (
                      <div className="p-1" key={product.product_id}>
                        <SingleProducts
                          item={product}
                          isSlider={true}
                          isList={productDisplay !== "grid"}
                        />
                      </div>
                    ))}
                </div>
              </div>
            </div>

            {Math.ceil(data["product_total"] / limit["value"]) > 1 && (
              <ReactPaginate
                pageCount={Math.ceil(
                  data["product_total"] / limit["value"]
                )}
                containerClassName={"category-pagination"}
                onPageChange={pageSetter}
                pageRangeDisplayed={width > 650 ? 2 : 1}
                marginPagesDisplayed={width > 650 ? 1 : 1}
                previousLabel={<IoIosArrowBack />}
                previousLinkClassName={"arrowLink"}
                nextLinkClassName={"arrowLink"}
                nextLabel={<IoIosArrowForward />}
                activeClassName={"active-pagination-category"}
                forcePage={
                  parsedQueryString.page
                    ? parseInt(parsedQueryString.page) - 1
                    : 0
                }
              ></ReactPaginate>
            )}
          </div>
          )}
        </div>

        {productData?.seller_id !== "168" && product_id && (
          <div className="fixed z-50 flex flex-col md:flex-row justify-center  items-start gap-2 md:gap-4 bg-white bottom-0 left-0 w-full p-2 md:p-4 shadow-2xl ">
            <div className="md:border-r-[1px] md:pr-4 w-full md:w-max md:border-dgreyAddress flex items-start gap-2 md:gap-4 justify-between md:justify-center">
              <div className="flex items-start gap-2 md:gap-4 justify-center">
                <img
                  alt={productData.name}
                  src={productData.thumb}
                  className="md:h-20 w-12 h-15"
                  width={"100"}
                  height={"100"}
                  placeholdersrc="https://ishtari.com/static/product_placeholder_square.png"
                  loading="lazy"
                />

                <div className="flex flex-col">
                  <span
                    className="text-dblack font-semibold text-[12px] max-w-screen-xs leading-4 flex justify-start"
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHTML(productData.name),
                    }}
                  ></span>

                  {productData["quantity"] <= 5 &&
                    productData["quantity"] > 0 && (
                      <div className="flex text-d14 mt-2 md:mt-4">
                        <div className="text-dbase">
                          Low stock: only {productData["quantity"]} left
                        </div>
                      </div>
                    )}

                  <div className="my-1 md:mt-4">
                    <div className="flex justify-between">
                      {productData?.options &&
                        productData.options?.length > 0 && (
                          <div className="flex justify-between items-center">
                            <h3
                              className="text-sm"
                              style={{ color: "rgb(126, 133, 155)" }}
                            >
                              {`${productData["options"]["0"]["name"]} ${
                                viewColor ? ":" : ""
                              }`}
                            </h3>
                            <span className="flex ml-1 font-semibold text-sm w-28">
                              {viewColor}
                            </span>
                          </div>
                        )}
                      {productData?.datasheet && (
                        <div
                          className={` text-right cursor-pointer text-sm ${
                            productData.options?.length > 0 ? "w-1/2" : "w-full"
                          } `}
                          onClick={() => downloadDatasheet()}
                        >
                          <div className="tooltipp">
                            <span className="tooltiptextt text-xs">
                              preview to download
                            </span>
                            <u className="underline_effect">Datasheet</u>
                          </div>
                        </div>
                      )}
                      {productData?.options &&
                        productData.options?.length > 0 &&
                        productData["options"]["0"]["size_guide"] && (
                          <h2
                            className="w-1/2 text-right "
                            onClick={() => setShowNewSizeGuide(true)}
                          >
                            {" "}
                            <u className="underline_effect cursor-pointer text-sm">
                              Size Guide
                            </u>
                          </h2>
                        )}
                    </div>{" "}
                    {productData?.options &&
                      productData.options?.length > 0 && (
                        <div className="flex flex-wrap ">
                          {productData["options"]["0"]["option_value"].map(
                            (option) => (
                              <div className="mr-3">
                                {/* <p className="text-xs text-center">
                                {option["name"]}
                              </p> */}
                                <div
                                  key={option.image}
                                  className={`p-1 border mr-2 my-2 cursor-pointer hover:shadow w-10 md:w-12 md:h-12 rounded relative ${
                                    option.product_option_value_id ===
                                    activeOption.product_option_value_id
                                      ? "border-dblue"
                                      : " border-dgrey"
                                  }`}
                                  onClick={() => {
                                    setOption(option);
                                    setColorSelected(option["name"]);
                                  }}
                                  onMouseOver={() => {
                                    setViewColor(option["name"]);
                                  }}
                                  onMouseLeave={() => {
                                    setViewColor(colorSelected);
                                  }}
                                >
                                  {option.quantity === "0" && (
                                    <div className=" bg-dgrey bg-opacity-50 w-full h-full absolute top-0 left-0 flex items-center justify-center cursor-not-allowed">
                                      <div className=" text-dblack text-4xl font-bold">
                                        X
                                      </div>
                                    </div>
                                  )}
                                  <LazyLoadImage
                                    src={option["image"]}
                                    key={option.image}
                                    alt={"Option"}
                                    placeholdersrc="https://www.sari3.com/ishtaridemo/product_placeholder.png"
                                  />
                                </div>
                                {accountState.admin && (
                                  <div className="w-full text-center font-bold">
                                    {option?.quantity}
                                  </div>
                                )}
                              </div>
                            )
                          )}
                        </div>
                      )}
                    {productData?.options &&
                      productData.options?.length > 0 &&
                      newSizeGuide && (
                        <div
                          className="fixed w-screen h-full min-h-screen top-0 left-0  bg-opacity-30 bg-dblack z-30"
                          onClick={() => setShowNewSizeGuide(false)}
                        ></div>
                      )}
                    <div>
                      {productData?.options &&
                        productData.options?.length > 0 && (
                          <div
                            className=""
                            // onClick={() => setShowNewSizeGuide(false)}
                          >
                            <div
                              className={` top-0  bg-white right-0 lg:w-1/3 w-10/12 min-h-screen transform  fixed h-full z-40 
                               ease-in-out duration-300 ${
                                 newSizeGuide
                                   ? "translate-x-0 "
                                   : "translate-x-full"
                               }`}
                            >
                              <div>
                                <div
                                  className={`border-b-4 border-dborderColor ${
                                    width < 650 ? "mx-4" : "mx-6"
                                  }  `}
                                >
                                  <h4 className="mt-2 font-light text-dgrey1 text-d16">
                                    Size Guide
                                  </h4>
                                </div>
                                <div
                                  className={`flex flex-wrap justify-center items-center pr-1  `}
                                >
                                  <div>
                                    <LazyLoadImage
                                      src={
                                        productData["options"]["0"][
                                          "size_guide"
                                        ]
                                      }
                                      className={`${
                                        width < 650 ? "pb-24" : "pb-1 "
                                      }`}
                                      alt="express"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="product-price  h-full  ">
                <div
                  className={`text-dblack ${
                    productData.special !== "0" ? "text-d20 font-bold " : ""
                  }`}
                >
                  {productData.special !== "0"
                    ? productData.special
                    : productData.price}
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-3 w-full md:w-fit">
              <div class="w-full md:w-max flex flex-col gap-2">
                {productData["quantity"] <= 5 &&
                  productData["quantity"] > 0 && (
                    <div className="w-16 text-d15  font-semibold">Quantity</div>
                  )}
                {productData.price != "$0" && (
                  <div className={`flex gap-2 `}>
                    {!accountState.admin ? (
                      <input
                        onChange={(e) => setQuantity(e.target.value)}
                        type="number"
                        value={quantity}
                        className={`${
                          productData["quantity"] === "0" ? "hidden" : ""
                        }border w-16 h-12 rounded text-dblack text-center border-dgrey1 text-xl `}
                      />
                    ) : (
                      <div className="qty-picker font-semibold cursor-pointer">
                        <div className="relative box-border">
                          <div className="flex items-center justify-center border border-dgreyQtyProduct rounded-md relative h-12 py-2 px-1.5">
                            <div className="mx-3">{quantity}</div>
                            <div className="flex items-center">
                              <div
                                style={{ width: "1px" }}
                                className="dividor h-7 bg-dgreyQtyProduct "
                              ></div>
                              <div className="px-1">
                                <FiChevronDown
                                  className="text-dgreyQtyProduct h-6 w-6"
                                  style={{
                                    // transform: toggleQty ? "rotate(-180deg)" : "",
                                    transition: "transform 0.2s ease",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="flex flex-col w-full">
                      <button
                        className={` text-white  w-full md:w-[170px] lg:w-[200px] h-12 relative rounded  ml-1  ${
                          productData["quantity"] === "0"
                            ? "bg-dbase mr-1"
                            : "bg-dblue mx-1 hover:bg-dbluedark"
                        } flex items-center justify-center rounded-md text-white `}
                        onClick={() => {
                          productData["quantity"] === "0"
                            ? console.log("")
                            : gtag_report_conversion();
                        }}
                      >
                        <span>
                          {productData["quantity"] === "0" ? (
                            "Out Of Stock"
                          ) : (
                            <div>
                              {/* <p
                                      className={`absolute z-10  transition duration-100 ease-in left-5 md:left-14 top-3 text-dblackk${
                                         
                                        countDown &&
                                        !countDownPointer
                                          ? "translate-x-0 "
                                          : "translate-x-full invisible"
                                      } `}
                                    >
                                      <span className="bg-white  px-2 rounded-full text-dblue">
                                        1
                                      </span>{" "}
                                      item  Added to the basket
                                    </p> */}
                              {countDownPointer === true &&
                              hasAddToCartError === false ? (
                                <div className="top-5 lds-ellipsis">
                                  <div />
                                  <div />
                                  <div />
                                  <div />
                                </div>
                              ) : (
                                !addingToCart && (
                                  <span className="">Add To basket </span>
                                )
                              )}
                            </div>
                          )}
                        </span>{" "}
                      </button>
                      <div className="w-full flex items-center justify-center pr-semibold mt-1 mobile:text-d18 text-dbluedark sm:text-md xs:text-xs">
                        {purchased &&
                          purchased > 100 &&
                          purchased + " Customers Purchased"}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {hasAddToCartError && (
                <div className=" bg-dbase text-white text-center h-11 rounded bg-opacity-80 capitalize relative flex items-center">
                  <span className="pl-2">{AddToCartError}</span>
                  <span
                    onClick={() => {
                      setHasAddToCartError(false);
                    }}
                    className=" rounded absolute top-0 right-0 cursor-pointer w-11 h-11 flex items-center justify-center hover:bg-white hover:text-dbase border border-dbase border-l-0"
                  >
                    <span className="text-xl">X</span>
                  </span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default Catalogv2;
